import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import * as Lmap from 'leaflet';
@Component({
  selector: 'emi-map',
  standalone: true,
  imports: [],
  templateUrl: './emi-map.component.html',
  styleUrls: ['./emi-map.component.css']
})
export class EmiMapComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() lat: any;
  @Input() long: any;
  @Input() name: any;
  @Input() hight?: any;
  @Input() id?: any;

  public localLat: any;
  public idLocal: any;
  public localLong: any;
  public localName: string = '';
  public localHight = '400px';
  private zoomMap: any = 18;
  private readonly customLeafIcon = Lmap.DivIcon.extend({
    options: {
      html: "<div style='background-color:#4838cc;' class='marker-pin'></div>",
      iconSize: [30, 42],
      iconAnchor: [15, 42],
    },
  });
  constructor() { }

  ngOnInit(): void {

  }
  ngAfterViewInit(): void {
    if (this.localLat && this.localLong) {
      this.createMap(this.localLat, this.localLong);
    }
  }
  ngOnChanges(): void {
    this.localLat = this.lat;
    this.localLong = this.long;
    this.localName = this.name;
    this.idLocal = this.id || 'map';
    if (this.hight) {
      this.localHight = this.hight
    }
  }

  private createMap(latitudeCoor: any, longitudeCoor: any) {
    const latitude = latitudeCoor;
    const longitude = longitudeCoor;
    let map = Lmap?.map(this.idLocal, {
      center: [latitude, longitude],
      zoom: this.zoomMap,
    });

    const greenIcon = new this.customLeafIcon({
      className: 'custom-green-marker',
    });

    let customMarker = greenIcon;

    Lmap.marker([latitude, longitude], { icon: customMarker, draggable: true })
      .addTo(map)
      .bindPopup(
        '<div style="font-size: 9px; text-align: center;">' +
        this.localName
        + '</div>'
      )
      .openPopup();

    const tiles = Lmap.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: this.zoomMap, });
    tiles.addTo(map);
  }

}
